import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/activeClientsSagas";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import MonthPicker from "../../../../components/reactMonthPicker/reactMonthPicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();

  const dateFormat = useDateFormat();
  const { startDate, endDate } = useSelector((state) => state.activeClients.selectedRequestDates);
  const period_type = useSelector((state) => state.activeClients.selectedFilters.period_type);

  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.activeClients.currentUser
  );

  return period_type === "Daily" ? (
    <ReactDatePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      isRangePicker
      showDefaultInputIcon={false}
      minDate={calendarStartDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    />
  ) : (
    <MonthPicker
      startDate={startDate}
      endDate={endDate}
      calendarStartDate={calendarStartDate}
      calendarEndDate={calendarEndDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    />
  );
};

export default DatePicker;
